import { makeAutoObservable } from "mobx";

export class ExampleStore {
  example: boolean = false;

  constructor() {
    makeAutoObservable(this, {}, { deep: true });
  }

  setExample = (val: boolean) => {
    this.example = val;
  };
}
